<template>
   <swiper
    :breakpoints="{
      0:   { slidesPerView: 1, spaceBetween: 12 },
      576: { slidesPerView: 1, spaceBetween: 16 },
      768: { slidesPerView: 2, spaceBetween: 24 },
      992: { slidesPerView: 3, spaceBetween: 30 },
    }"
    :pagination="{ clickable: true }"
    :navigation="true"
    :modules="modules"
    class="mySwiper"
    :autoplay="{ delay: 2500, disableOnInteraction: false }"
  >
  
    <swiper-slide>
      <img
        src="../assets/karussellKondi8.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi1.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi2.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi3.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi4.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi5.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi6.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    <swiper-slide>
      <img
        src="../assets/karussellKondi7.jpg"
        class="swiper-slide rundeEcken"
      />
    </swiper-slide>
    
  </swiper>
</template>

<!-- 
HILFE !!
https://swiperjs.com/demos#effect-fade 
-->

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import "../../assets/mySwiper.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { openModal } from "jenesius-vue-modal";
import ModalPic from "../components/Modals/ModalPic.vue";

export default {
  name: "karussellAktuelles1",
  components: {
    Swiper,
    SwiperSlide,
  },

  methods: {
    async openPic(pic) {
      if (window.innerWidth >= 768) {
        const props = { adressePic: pic };
        const modal = await openModal(ModalPic, props);
        modal.onclose = () => {
          return true;
        };
      }
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
